globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.NotificationFlash = (function() {

  function NotificationFlash($flash) {
    this.$flash = $flash;
    this.$closeBtn = this.$flash.find(".close-flash");

    this.init();
  }

  NotificationFlash.initFlash = function() {
    var $flash = $('#notification-flash');

    if($flash.length) new NotificationFlash($flash);
  }

  NotificationFlash.prototype = {
    init: function() {
      var _this = this;

      if(!$('body').find(this.$flash.attr('id')).length) {
        $('body').append(this.$flash);
      }

      setTimeout(function(){ _this._close() }, 5000);
      _this.$closeBtn.on("click", function(){ _this._close() });
    },
    _close: function(){
      this.$flash.fadeOut(400);
    }
  }

  return NotificationFlash;

})();
